
//Représente les paramètres de mise à jour de la référence de commande d’une facture d’achat
export class AeFMettreAJourRefCommandeFactureAchatParametres 
{
  //Identifiant de la facture
  public identifiantFacture!: string;

  //Numéro de commande
  public numeroCommande!: string;
}
